// extracted by mini-css-extract-plugin
export default {"container":"ForecastBoard_container__DP+f+","moreRight":"ForecastBoard_moreRight__EbTZ9"};